export async function terminateFreshChatWidget() {
  if (window.fcWidget) {
    await window.fcWidget.user
      .clear()
      .then((result) => {})
      .catch((err) => {
        console.log(err);
      });

    window.fcWidget.destroy();

    const isScriptPresent = document.getElementById("freshchat-js-sdk");

    const freshworksScript = document.querySelector('script[chat="true"]');

    if (isScriptPresent) {
      document.head.removeChild(isScriptPresent);
    }

    if (freshworksScript) {
      document.head.removeChild(freshworksScript);
    }
    delete window.fcSettings;
    delete window.fcWidget;
  }
}
